import React, { useState, useEffect } from 'react';
import proptypes from 'prop-types';
const { arrayOf, bool, number, shape, string } = proptypes;
import {
  Radio,
  RadioGroup,
  SelectionControlLabel,
  Typography
} from '@one-thd/sui-atomic-components';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { usePartsAndServices } from '../PartsAndServicesProvider';
import { isEmptyObject } from '../../utils';

const ProtectionPlanRadioBtnsLabel = ({ protectionPlan }) => {
  const { price, termLength } = protectionPlan;
  const protectionPlanPrice = Number(price);
  const costPerMonth = protectionPlanPrice / (termLength * 12);

  return (
    <div className="sui-flex sui-flex-wrap">
      <Typography>
        {termLength} Year Protection Plan
      </Typography>
      <div className="sui-flex">
        <Typography weight="bold">
          &nbsp;${protectionPlanPrice.toFixed(2)}
        </Typography>
        <div className="sui-self-center">
          <Typography variant="body-xs">
          &nbsp;(${costPerMonth.toFixed(2)}/month)
          </Typography>
        </div>
      </div>
    </div>
  );
};

ProtectionPlanRadioBtnsLabel.propTypes = {
  protectionPlan: shape({
    description: string,
    price: number,
  }).isRequired,
};

export const ProtectionPlanRadioBtns = ({ lineItemId, protectionPlans }) => {
  const {
    initializeProtectionSelections,
    protectionSelections,
    setProtectionSelections
  } = usePartsAndServices();

  const theme = useTheme(ProtectionPlanRadioBtns);
  const { defaultDeclineCoverage } = theme.props;
  useEffect(() => {
    if (isEmptyObject(protectionSelections)) {
      initializeProtectionSelections();
    }
  }, []);

  let index = defaultDeclineCoverage ? -1 : 0;
  if (protectionSelections[lineItemId] !== undefined) {
    index = protectionPlans.findIndex((item) => item.configAttr === protectionSelections[lineItemId]?.configAttr);
  }
  const [radioValue, setRadioValue] = useState(index);
  useEffect(() => {
    setRadioValue(index);
  }, [protectionSelections]);

  const onChange = (event) => {
    const selectionIndex = event.target.value;
    setRadioValue(selectionIndex);
    setProtectionSelections(lineItemId, protectionPlans[selectionIndex] || {});
  };

  if (!protectionPlans || !protectionPlans.length) return null;

  return (
    <>
      <RadioGroup
        name="protection-radio-buttons-group"
        onChange={onChange}
        value={radioValue}
      >
        {protectionPlans.map((protectionPlan, i) => (
          <SelectionControlLabel
            alignment="top"
            key={protectionPlan.configAttr}
            value={i}
            label={<ProtectionPlanRadioBtnsLabel protectionPlan={protectionPlan} />}
          >
            <Radio />
          </SelectionControlLabel>
        ))}

        <SelectionControlLabel value={-1} label="Decline Protection">
          <Radio />
        </SelectionControlLabel>
      </RadioGroup>
    </>
  );
};

ProtectionPlanRadioBtns.propTypes = {
  lineItemId: string.isRequired,
  protectionPlans: arrayOf(shape({
    description: string,
    installation: bool,
    price: number,
    configAttr: string,
    termLength: number,
    category: string
  }))
};

ProtectionPlanRadioBtns.defaultProps = {
  protectionPlans: []
};

ProtectionPlanRadioBtns.themeProps = {
  defaultDeclineCoverage: bool
};

ProtectionPlanRadioBtns.defaultThemeProps = {
  defaultDeclineCoverage: false
};

ProtectionPlanRadioBtns.displayName = 'ProtectionPlanRadioBtns';
